import { t } from '@framework/i18n/intl/i18next.ts';
import { yup } from '@framework/validation/initYup.ts';
import { RuleType } from '../../IRule.ts';
import { type IRuleType } from '../../IRuleType.ts';
import { FractionDigitsRuleComponent } from './FractionDigitsRuleComponent.tsx';

const configValidator = yup
  .object({
    value: yup
      .number()
      .notRequired()
      .min(0)
      .integer()
      .label('Numero massimo di cifre decimali'),
    customMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
  })
  .notRequired()
  .noUnknown();

type IRuleFractionDigitsType = yup.InferType<typeof configValidator>;

export const FractionDigitsRule: IRuleType<IRuleFractionDigitsType> = {
  type: RuleType.FractionDigits,
  name: 'Numero massimo di cifre decimali',
  configComponent: FractionDigitsRuleComponent,
  configValidator,
  validator: (schema, rule) => {
    if (rule?.value == null) return schema;

    const max = rule.value;

    return (schema as yup.NumberSchema).test({
      name: 'fraction-digits',
      params: { max },
      skipAbsent: true,
      message:
        rule.customMessage ??
        t(
          'rules.fraction-digits.max',
          'Il campo ${label} non può avere più di {{max}} cifre decimali',
          { max },
        ),
      test(value) {
        if (value == null) return true;
        const decimalPart = String(Math.abs(value)).split('.')[1];
        if (!decimalPart) return true;
        return decimalPart.length <= max;
      },
    });
  },
};
